import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export interface Crumb {
  label: string;
  to?: string; // no href → current-page (last crumb)
}

export function Breadcrumbs({ items }: { items: Crumb[] }) {
  if (items.length === 0) return null;
  return (
    <nav className="flex items-center gap-1 text-sm text-muted-foreground" aria-label="Breadcrumb" data-region="breadcrumbs">
      {items.map((crumb, i) => {
        const last = i === items.length - 1;
        return (
          <span key={i} className="flex items-center gap-1">
            {crumb.to && !last ? (
              <Link to={crumb.to} className="hover:text-foreground hover:underline">{crumb.label}</Link>
            ) : (
              <span className={last ? "text-foreground" : ""} aria-current={last ? "page" : undefined}>{crumb.label}</span>
            )}
            {!last && <ChevronRight className="h-3.5 w-3.5" aria-hidden />}
          </span>
        );
      })}
    </nav>
  );
}
